export const PAYROLL_COMPONENT_PERMISSION_CODES = {
    WEB_PAYROLL_COMPONENT_LIST: 'WEB_PAYROLL_COMPONENT_LIST',
    WEB_PAYROLL_COMPONENT_DETAIL: 'WEB_PAYROLL_COMPONENT_DETAIL',
    WEB_PAYROLL_COMPONENT_ADD: 'WEB_PAYROLL_COMPONENT_ADD',
    WEB_PAYROLL_COMPONENT_EDIT: 'WEB_PAYROLL_COMPONENT_EDIT',
    WEB_PAYROLL_COMPONENT_DELETE: 'WEB_PAYROLL_COMPONENT_DELETE',
    WEB_PAYROLL_COMPONENT_IMPORT: 'WEB_PAYROLL_COMPONENT_IMPORT',
    WEB_PAYROLL_COMPONENT_EXPORT: 'WEB_PAYROLL_COMPONENT_EXPORT',
} as const;


